<template>
  <div id="app">
    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <Booking :eventData="events" v-if="events !== null" />
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import Header from "../components/Header.vue";
import Booking from "../components/Booking.vue";
import moment from "moment";
import { Event } from "../classes/Event";
export default {
  components: {
    Header,
    Booking
  },
  async created() {
    this.loader = true;

    const date = moment()
      .subtract(1, "day")
      .format("YYYY-MM-DD");
    const user = await Auth.currentAuthenticatedUser();

    let nextEvents = await new Event().getEventsByConsultant({
      date: date,
      consultant: user.attributes.email,
      nextToken: null
    });
    let events = nextEvents.items;
    this.nextToken = nextEvents.nextToken;
    while (this.nextToken !== null) {
      nextEvents = await new Event().getEventsByConsultant({
        date: date,
        consultant: user.attributes.email,
        nextToken: this.nextToken
      });
      events.push(...nextEvents.items);
      this.nextToken = nextEvents.nextToken;
    }
    this.events = events;
    this.loader = false;
  },
  data() {
    return {
      loader: false,
      events: null
    };
  }
};
</script>
